import {HttpClient} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import {ICustomerInfo, ICustomerProfileState} from '../models/header.model';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private readonly _httpClient = inject(HttpClient);


  getCustomerProfile(): Observable<ICustomerProfileState> {
    const getOrganizationsUrl = `${environment.api.baseUrl}${environment.api.header.getCustomerProfile}`;

    return this._httpClient.get<ICustomerProfileState>(getOrganizationsUrl);
  }

  updateCustomerProfile(customer: ICustomerInfo): Observable<ICustomerProfileState> {
    const getOrganizationsUrl = `${environment.api.baseUrl}${environment.api.header.updateCustomerProfile}`;

    return this._httpClient.put<ICustomerProfileState>(getOrganizationsUrl, customer);
  }
}
